<template>
  <div>
    <a-form
        :form="form"
        :label-col="{ span: 9 }"
        :wrapper-col="{ span: 7 }"
        @submit="submit"
    >
      <h3 style="text-align: center; margin-top: 48px">Dom studencki</h3>
      <a-form-item label="Numer pokoju">
        <a-input
            v-decorator="[
            'dormRoom',
            {
              rules: [
                {
                  required: true,
                  message: 'Numer pokoju jest wymagany!',
                },
                {
                  pattern: /\b\d\d[AB|ab]\b|\b(\d\d\d|\d\d|\d)\b/g,
                  message:
                    'Podaj prawidłowy numer pokoju! (Przykłady: 512, 123, 12A, etc.)',
                },
              ],
            },
          ]"
            :maxLength="3"
        />
      </a-form-item>
      <h3 style="text-align: center; margin-top: 48px">Dane studenta</h3>
      <p style="text-align: center; max-width: 600px; margin: 12px auto">
        Jeśli nie jesteś studentem uczelni wyższej to nie musisz wypełniać
        podanych poniżej pól.
      </p>
      <a-form-item label="Uczelnia">
        <a-input v-decorator="['name']" :allowClear="true" :maxLength="250"/>
        <div style="line-height: 1.4em">
          <a-tag
              v-for="university in universities"
              :key="university.short"
              style="cursor: pointer; margin: 2px 2px"
              @click="setUniversity(university.value)"
          >
            {{ university.short }}
          </a-tag>
        </div>
      </a-form-item>
      <a-form-item label="Kierunek studiów">
        <a-input v-decorator="['faculty']" :maxLength="250"/>
      </a-form-item>
      <a-form-item has-feedback label="Semestr">
        <a-select
            v-decorator="['semester']"
            placeholder="Wybierz numer semestru z listy..."
        >
          <a-select-option
              v-for="semester in semesters"
              :key="semester.key"
              :defaultValue="0"
              :value="semester.key"
          >
            {{ semester.value }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="Numer albumu (indeksu)">
        <a-input
            v-decorator="['index']"
            :maxLength="20"
            placeholder="np. 0000000"
        />
      </a-form-item>
    </a-form>

    <a-row style="text-align: center">
      <a-button style="margin-right: 24px" type="default" @click="back">
        <a-icon type="left"/>
        Wróć
      </a-button>
      <a-button
          :disabled="!isVerificationCompleted"
          type="primary"
          @click="submit"
      >
        Dalej
        <a-icon type="right"/>
      </a-button>
    </a-row>
  </div>
</template>

<script>
const universitiesDictionary = [
  {
    short: "PŚk",
    value: "Politechnika Świętokrzyska w Kielcach",
  },
  {
    short: "UJK",
    value: "Uniwersytet Jana Kochanowskiego w Kielcach",
  },
  {
    short: "WSEPiNM",
    value: "WSEPiNM im. prof. E. Lipińskiego w Kielcach",
  },
  {
    short: "AWANS",
    value: "Centrum Kształcenia AWANS KIELCE",
  },
];

const semestersDictionary = [
  {key: 1, value: "pierwszy"},
  {key: 2, value: "drugi"},
  {key: 3, value: "trzeci"},
  {key: 4, value: "czwarty"},
  {key: 5, value: "piąty"},
  {key: 6, value: "szósty"},
  {key: 7, value: "siódmy"},
  {key: 8, value: "ósmy"},
  {key: 9, value: "dziewiąty"},
  {key: 10, value: "dziesiąty"},
  {key: 11, value: "jedenasty"},
  {key: 12, value: "dwunasty"},
  {key: 13, value: "trzynasty"},
  {key: 14, value: "czternasty"},
  {key: 15, value: "piętnasty"},
  {key: 16, value: "inny"},
  {key: 0, value: "nie dotyczy"},
];

export default {
  data() {
    return {
      universities: universitiesDictionary,
      semesters: semestersDictionary,
      formLayout: "horizontal",
      form: this.$form.createForm(this, {name: "coordinated"}),
    };
  },
  mounted() {
    let data = this.$store.getters["getDormAndUniversityData"];
    this.form.setFieldsValue({
      dormRoom: data.dormRoom,
      name: data.name,
      faculty: data.faculty,
      semester: data.semester,
      index: data.index,
    });
  },
  methods: {
    submit: function () {
      this.form.validateFields((errors, values) => {
        if (!errors) {
          this.$store.commit("updateDormAndUniversityData", values);
          this.$emit("nextStep");
        }
      });
    },
    back: function () {
      this.$emit("prevStep");
    },
    setUniversity(value) {
      this.form.setFieldsValue({
        name: value,
      });
    },
  },
  computed: {
    isVerificationCompleted: function () {
      return true;
    },
  },
};
</script>
